import React, {useCallback, useEffect, useMemo, useRef, useState} from 'react';
import UnreconciledService from "../../services/UnreconciledService";
import CFAdminDataTable from "../../components/CFAdminDataTable";
import CFAdminNotification from "../../components/CFAdminNotification";
import CFAdminConfirmDialog from "../../components/CFAdminConfirmDialog";
import EditIcon from "../../assets/images/icons8-edit.svg";

const ActionsCell = (props: any) => {
    const { row, column } = props;
    return (
        <div className="cell-buttons">
            <button
                data-testid="cell-apply-rule-button"
                className="edit-button"
                onClick={() => column.promptApplyRule(row.original)}
                title="Apply Rule"
            >
                <img src={EditIcon} alt="Apply Rule" height="15"/>
            </button>
        </div>
    );
};

const baseColumnDefinitions: Array<[string, string]> = [
    ["Id", "id"],
    ["VinPattern", "vinSigniPattrnMask"],
    ["Make", "makeN"],
    ["Model", "modelX"],
    ["Series", "trimX"],
    ["DriveTrain", "drvTypX"],
    ["Cylinders", "engClndrRTRT"],
    ["Fuel", "engFuelX"],
    ["Transmission", "transX"],
    ["Engine", "engDisplcmntLTRX"],
    ["VehicleType", "vehTypX"],
    ["Year", "modelYear"],
    ["BodyStyle", "bodyStyleX"],
    ["GVWR", "trkGrssVehWghtRtX"],
];

function CFAdminUnreconcileVins() {
    const childCompRef = useRef<any>();
    const [data, setData] = useState([]);
    const [isConfirmOpen, setIsConfirmOpen] = useState(false);
    const [selectedRow, setSelectedRow] = useState<any>(null);

    const promptApplyRule = useCallback((row: any) => {
        setSelectedRow(row);
        setIsConfirmOpen(true);
    }, []);

    const columns = useMemo(() => {
        const mappedColumns = baseColumnDefinitions.map(([Header, accessor]) => ({Header, accessor}));
        return [
            ...mappedColumns,
            {
                Header: "Actions",
                Cell: ActionsCell,
                promptApplyRule: promptApplyRule
            }
        ];
    }, [promptApplyRule]);

    useEffect(() => {
        retrieveUnreconciledVins();
    }, []);

    const retrieveUnreconciledVins = async () => {
        const status = '6';
        UnreconciledService.getAllUnreconciledVins(status)
            .then(response => {
                setData(response.data || []);
            })
            .catch(e => {
                console.error(e);
                childCompRef.current?.failureMessage('Failed to retrieve unreconciled vins');
            });
    };

    const closeConfirm = () => {
        setIsConfirmOpen(false);
        setSelectedRow(null);
    };

    const handleApplyRule = async () => {
        if (!selectedRow) {
            return;
        }
        try {
            await UnreconciledService.applyRules(selectedRow.id);
            childCompRef.current?.successMessage('Rule applied successfully');
            closeConfirm();
            retrieveUnreconciledVins();
        } catch (error) {
            console.error(error);
            const backendMessage = (error as any)?.response?.data?.errorMessage;
            childCompRef.current?.failureMessage(backendMessage || 'Failed to apply rule');
            closeConfirm();
        }
    };

    return (
        <div className="operations-component">
            <h2 className="fomo-type--title">Unreconciled Vin List</h2>
            <CFAdminDataTable
                columns={columns}
                data={data}
                toggleModal={''}
                textModal={'none'}
            />
            <CFAdminConfirmDialog
                isOpen={isConfirmOpen}
                onClose={closeConfirm}
                onConfirm={handleApplyRule}
                title="Apply Rule"
                text="Are you sure you want to apply the rule to this VIN?"
            />
            <CFAdminNotification ref={childCompRef}/>
        </div>
    );
}

export default CFAdminUnreconcileVins;